module.exports = "/images/icon_72_rightchev.png?41080903e21f63e26867d8992e4195a0";